export default function PreviewChannelSwitcher() {
  return null;
}
